// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubHeading_wrapper__E7j_M","hidden":"SubHeading_hidden__dhwnm","moreTextWrapper":"SubHeading_moreTextWrapper__MOHnM","moreText":"SubHeading_moreText__arYCQ"};